import MenuIcon from './MenuIcon'

export default MenuIcon


// WEBPACK FOOTER //
// ./src/components/Menu/MenuIcon/index.js